export default __webpack_public_path__ + "f19d970ef64102af900c6fd2fb5de6ff.png";